/* ==========================================================================
   Hemp Heart Comparison Table — hemp-heart-comp-table.js
   Lightweight, dependency-free scroll reveal + theme-editor live sync.
   Namespaced so multiple instances of the section can exist on one page.
   ========================================================================== */

(function () {
  'use strict';

  function initTableScroll(section) {
    var wrap = section.querySelector('.hhct__table-wrap');
    var table = section.querySelector('.hhct__table');
    if (!wrap || !table) return;

    function update() {
      var isScrollable = table.scrollWidth > wrap.clientWidth + 1;
      wrap.classList.toggle('hhct--scrollable', isScrollable);
      var atEnd = wrap.scrollLeft + wrap.clientWidth >= table.scrollWidth - 1;
      wrap.classList.toggle('hhct--scrolled-end', !isScrollable || atEnd);
    }

    update();
    wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function initSection(section) {
    if (!section || section.dataset.hhctInit === 'true') return;
    section.dataset.hhctInit = 'true';

    initTableScroll(section);

    var animateEnabled = section.dataset.animate === 'true';
    var targets = section.querySelectorAll('.hhct__animate');

    if (!animateEnabled || !targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('hhct--in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hhct--in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index * 60, 360) + 'ms';
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('.hhct[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init on Shopify section reload / theme editor changes */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.hhct[data-section-id]');
    if (section) {
      section.dataset.hhctInit = 'false';
      initSection(section);
    }
  });

  /* Refresh selects/inputs live while editing in the theme editor */
  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target.querySelector('.hhct[data-section-id]');
    if (section) {
      section.querySelectorAll('.hhct__animate').forEach(function (el) {
        el.classList.add('hhct--in-view');
      });
    }
  });
})();
